export default {
  "content": "<path d=\"M12 12a4 4 0 100-8 4 4 0 000 8zm0 2c-4.5 0-8 3-8 6h16c0-3-3.5-6-8-6z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  }
};